import styled from 'styled-components';

export const Container = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
`;
